<div class="text-center mt-5" *ngIf="images.length > 1">
    <i class="fas fa-chevron-left chevron" (click)="goBack()"></i>
    {{currentIdx + 1}} de {{images.length}}
    <i class="fas fa-chevron-right chevron" (click)="goAhead()"></i>
</div>

<div class="text-center mv-10">
    {{currentCaption}}
</div>

<div style="height: 500px; text-align: center">
    <img alt="..." [src]="currentImage" class="border-0" style="width:700px; margin-left: 20px;" />
</div>
